import { render, staticRenderFns } from "./ButtonBuyOnline.vue?vue&type=template&id=670bbcfa&scoped=true&"
import script from "./ButtonBuyOnline.vue?vue&type=script&lang=ts&"
export * from "./ButtonBuyOnline.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonBuyOnline.vue?vue&type=style&index=0&id=670bbcfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670bbcfa",
  null
  
)

export default component.exports